import React from 'react';
import AsyncPartnerSettingsAccountInfo from './accountinfo/async';
import AsyncPartnerSettingsUpdateAccount from './updateaccount/async';
import SingleColumnLayout from '../../../components/layout/SingleColumnLayout';
import {Trans} from 'react-i18next';

const parent = {
  title: <Trans i18nKey="p.p.partner.title">Online Service Partner</Trans>,
  path: '/partner',
};
export default [
  <SingleColumnLayout
    exact
    key="partner-settings-account-info"
    path="/partner/settings"
    className="kt-portlet--solid-gray"
    component={AsyncPartnerSettingsAccountInfo}
    title={<Trans i18nKey="p.p.settings.title">Settings</Trans>}
    parents={[parent]}
  />,
  <SingleColumnLayout
    exact
    key="partner-settings-edit-account"
    path="/partner/settings/edit-account"
    className="kt-portlet--solid-gray"
    component={AsyncPartnerSettingsUpdateAccount}
    title={<Trans i18nKey="p.p.settings.title">Settings</Trans>}
    parents={[parent]}
  />,
];
